document.addEventListener('DOMContentLoaded', function () {
  const list = document.getElementById('video-faq-list');
  if (!list) return;

  const openItem = (item) => {
    const answer = item.querySelector('.faq-item__answer');
    if (!answer) return;
    item.classList.add('is-open');
    answer.style.maxHeight = answer.scrollHeight + 'px';
  };

  const closeItem = (item) => {
    const answer = item.querySelector('.faq-item__answer');
    if (!answer) return;
    item.classList.remove('is-open');
    answer.style.maxHeight = null;
  };

  const openFirstItem = () => {
    const items = list.querySelectorAll('.faq-item');
    items.forEach((item, idx) => {
      if (idx === 0) {
        openItem(item);
      } else {
        closeItem(item);
      }
    });
  };

  list.addEventListener('click', function (event) {
    const button = event.target.closest('.faq-item__question');
    if (!button) return;
    const item = button.closest('.faq-item');
    if (!item) return;

    const isOpen = item.classList.contains('is-open');

    list.querySelectorAll('.faq-item').forEach((otherItem) => {
      if (otherItem !== item) closeItem(otherItem);
    });

    if (isOpen) {
      closeItem(item);
    } else {
      openItem(item);
    }
  });

  // The active tab's FAQ items are injected by video-page-tabs.js whenever the
  // tab changes. Re-open the first item any time that content is replaced.
  const observer = new MutationObserver(openFirstItem);
  observer.observe(list, { childList: true });

  openFirstItem();
});
